// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__D10iZ","containerItemsCenter":"Skeleton_containerItemsCenter__2oIrL"};